export default {
  methods: {
    /**
     * Sends friend request only if properly authenticated
     * @param {int} friendUserId
     * @returns {Promise<Object>} Returns the response data
     */
    addFriendById: async function (friendUserId) {
      const response = await this.$axios.put(`/v1/users/${this.$store.state.userId}/friendships/${friendUserId}`);
      this.$store.commit("decrementNotifications");
      return response.data;
    },

    removeFriendById: async function (friendUserId) {
      const response = await this.$axios.delete(`/v1/users/${this.$store.state.userId}/friendships/${friendUserId}`);
      return response.data;
    },

    /**
     * For use with api v1
     */
    getFriendshipStatus: async function (friendUserId) {
      try {
        const response = await this.$axios.get(`/v1/users/${this.$store.state.userId}/friendships/${friendUserId}`);
        return response.data.requestStatus;
      } catch (error) {
        if (error.response.status === 404) {
          return null;
        } else {
          console.log(error.response);
          console.error(error);
        }
      }
    },
  },
};
